import { useMemo } from 'react';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeProvider } from '@creditas-ui/system';
import { standard } from '@creditas-ui/themes';
import { extendsQueryClient } from './services/queryClient';
import { FlowsProvider } from './flows';
import { Listener } from './components/Listener';

const App = (props: any): JSX.Element => {
  const queryClient = useMemo(() => extendsQueryClient(props.queryClient), [props.queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={standard}>
        <FlowsProvider>
          <Listener />
        </FlowsProvider>

        {process.env.SHOW_REACT_QUERY_DEVTOOLS === 'true' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
